import script from "./componentTestData.vue?vue&type=script&lang=js"
export * from "./componentTestData.vue?vue&type=script&lang=js"

import "./componentTestData.vue?vue&type=style&index=0&id=0ccda9a2&lang=css"

const __exports__ = script;

export default __exports__